document.addEventListener('keydown', function(event) {
  // Check for the "Escape" key
  if (event.key === "Escape" || event.keyCode === 27) {
    // Check if any submenu checkbox is checked (i.e., a submenu is open)
    const checkedSubmenuInput = document.querySelector('.submenu__input:checked');
    if (checkedSubmenuInput) {
      // Find the parent list item to locate the trigger
      const parentListItem = checkedSubmenuInput.closest('.mobile-menu__list-item');
      if (parentListItem) {
        // Uncheck the checkbox to close the submenu
        checkedSubmenuInput.checked = false;

        // Find and return focus to the trigger link
        const triggerLink = parentListItem.querySelector('.mobile-menu-link');
        if (triggerLink) {
          triggerLink.focus();
          event.stopPropagation(); // Stop the event from propagating further
          return; // Exit the function
        }
      }
    }

    // This block handles the top-level menu closure and is likely already working
    // If no submenu is open, check if the top-level menu is open
    // This assumes there's a main menu toggle with a class or ID
    const mobileMenuContainer = document.querySelector('.mobile-menu-container'); 
    const menuToggle = document.querySelector('#mobile-menu-toggle'); 

    if (mobileMenuContainer && menuToggle && !mobileMenuContainer.classList.contains('is-hidden')) {
      // Logic to close the main menu
      mobileMenuContainer.classList.add('is-hidden'); 
      menuToggle.focus(); // Return focus to the main menu trigger
    }
  }
});
document.addEventListener('DOMContentLoaded', function() {
  const menuLinksWithSubmenus = document.querySelectorAll('.mobile-menu__first-level.has-submenu .mobile-menu-link');

  menuLinksWithSubmenus.forEach(link => {
    link.addEventListener('keydown', function(event) {
      // Check if the key pressed is Enter or Space
      if (event.key === 'Enter' || event.key === ' ') {
        // Prevent the default link navigation
        event.preventDefault();
        
        // Find the associated checkbox for this submenu
        const listItem = link.closest('.mobile-menu__list-item');
        if (listItem) {
          const submenuInput = listItem.querySelector('.submenu__input');
          if (submenuInput) {
            // Manually toggle the checkbox to open/close the submenu
            submenuInput.checked = !submenuInput.checked;
          }
        }
      }
    });
  });
});